// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"353":"e18663fa","488":"219a7f06"}[chunkId] + ".chunk.js";
};